import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/key.vue
var s = {
	name: "DtIconKey",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--key"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Key",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M10.854.647a.5.5 0 0 1 0 .707L10.207 2l1.147 1.147a.5.5 0 0 1 0 .707l-1.75 1.75a.5.5 0 0 1-.707 0L7.75 4.457 6.376 5.831a3.28 3.28 0 0 1 .638 1.92 3.275 3.275 0 0 1-.952 2.31 3.275 3.275 0 0 1-2.31.952 3.275 3.275 0 0 1-2.302-.968l-.003-.004a3.25 3.25 0 0 1 4.216-4.91L10.147.647a.5.5 0 0 1 .707 0ZM5.346 6.163a2.25 2.25 0 0 0-3.182 3.182c.416.42 1.001.666 1.592.668.592.002 1.18-.24 1.599-.66a2.275 2.275 0 0 0 .659-1.598 2.275 2.275 0 0 0-.668-1.592ZM8.457 3.75l.793.793L10.293 3.5 9.5 2.707 8.457 3.75Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=key.js.map